const input = {
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    email: 'E-posta Adresi',
    phone_number: 'Telefon Numarası',
    student_number: 'Öğrenci Numarası',
    registration_number: 'Kayıt Numarası',
    student_identifier_legend: 'Şununla giriş yap',
    confirm_password: 'Şifreyi Doğrula',
    search_region_code: 'Bölge kodunu ara',
    backup_code: 'Yedek kod',
    code: 'Kod',
    label_with_optional: '{{label}} (İsteğe bağlı)',
};
export default Object.freeze(input);
